import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Banner, FlexContainer, Sizes, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { userStageSelector } from 'Store/modules/validations/selectors';
import useTranslation from 'Hooks/useTranslation';
import { stages } from 'Constants/stages';

const AmountToReceive = ({
  amountResolved,
  partialAmount,
  isPartial,
  flexFee,
}: {
  amountResolved: number;
  partialAmount: number;
  isPartial: boolean;
  flexFee: number;
}): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const userStage = useSelector(userStageSelector);

  const formattedCost = useMemo(
    () =>
      t('AmountToReceive.cost', {
        context: isPartial && 'isPartial',
        cost: YayoyakiFormatter.formatAmountMxn(flexFee),
      }),
    [flexFee, t, isPartial]
  );

  return (
    <FlexContainer direction="column" justify="center" align="center" gap="dimension_16">
      <Text color="dark" type="headline" size="XS_L_S" align="center">
        {t('AmountToReceive.Title', {
          context:
            (isPartial && 'isPartial') || (userStage === stages.VALIDATION && 'isValidation'),
        })}
      </Text>
      {isPartial && (
        <Banner
          id="amount-to-receive-partial-banner"
          label={t('AmountToReceive.partial.label')}
          mode="warning"
          titleSize={Sizes.S}
          layout="embed"
        />
      )}
      <FlexContainer direction="column" align="flex-start" gap="dimension_16">
        <Text color="dark" size="M_M_S" type="paragraphs">
          {t('AmountToReceive.partial.sat.requested', {
            amount: YayoyakiFormatter.formatAmountMxn(Math.abs(amountResolved)),
          })}
        </Text>
        <Text color="success_strong" size="M_M_S" type="paragraphs">
          {t('AmountToReceive.subtitle', {
            context: isPartial && 'isPartial',
            amount: YayoyakiFormatter.formatAmountMxn(Math.abs(partialAmount)),
          })}
        </Text>
        <Text color="grey" type="paragraphs" size="S_M_S">
          {formattedCost}
        </Text>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AmountToReceive;
